<div
  class="check-card"
  [ngClass]="{
    'check-disabled': control.disabled && !control.value,
    hilite: hilite
  }"
>
  <mat-checkbox
    class="small"
    color="primary"
    [ngClass]="{
      hilitex: hilite
    }"
    [formControl]="control"
    (change)="changed.emit($event.checked)"
  >
    {{ title }}
  </mat-checkbox>
</div>
